export const ROUTES = {
  OPERATOR: {
    LOGIN: '/operator/login',
    MY_TASKS: '/operator/my-tasks',
    TASK_DETAILS: '/operator/my-tasks',
    SETUP: '/operator/setup',
  },
  AGENT: {
    LOGIN: '/agent/login',
    DASHBOARD: '/agent/dashboard',
  },
  HOME: {
    ROOT: '/',
    BOOKINGS: '/bookings',
  },
};
